import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { RolePermissions as R } from '../../features/role-permissions'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'

export function RolePermissions(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return (
    <>
      <R id={props.id || ''} />
    </>
  )
}
